import { _ } from '_core';

import { Params } from './types';

export const validate = (params: Params) => {
  if (_.isEmpty(params.analysis_time_series_ids)) return ['Time series is a required field.'];
  return [];
};
